<template>
  <div>
    <role-table :tableData="sysData" :storeType="storeType"></role-table>
  </div>
</template>

<script>
import RoleTable from '../../components/RoleTable'
export default {
  name: 'SysAuth',
  props: {
    sysData: Array,
    form: Object
  },
  data() {
    return {
      storeType: 'setCurAddSysAuthData'
    }
  },
  computed: {
    /* tableData() {
      return JSON.parse(JSON.stringify(this.sysData))
    } */
  },
  components: {
    RoleTable
  },
  mounted() {
  },
  methods: {
  }
}
</script>
